import { IEntity } from '../core/iEntity';
export interface IAuthEntity {
  authEntity?: IEntity | null;
}

class AuthEntityClass implements IAuthEntity {
  authEntity;

  constructor(authEntity?: IEntity) {
    this.authEntity = authEntity ?? null;
  }
}

export default AuthEntityClass;
